import { render, staticRenderFns } from "./OpenHours.vue?vue&type=template&id=6715f7e4"
import script from "./OpenHours.vue?vue&type=script&lang=js"
export * from "./OpenHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports